import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { AssetAssignment } from '../entities/asset-assignment';


export class AssetAssignmentRequest extends BaseRequest {
  
  assetAssignment : AssetAssignment;

  constructor(userInfo : UserInfo){    
    super(userInfo);
    this.assetAssignment = new AssetAssignment();
  }

}